export default "__VITE_ASSET__67ee1a8e__"